import { useTranslation } from "react-i18next";
import { Button } from "@chakra-ui/react";

import { SSOAuthenticationBox } from "modules/authentication/components/SSOAuthenticationBox";

const LoginOidcCallbackErrors = () => {
  const { t } = useTranslation();

  return (
    <SSOAuthenticationBox>
      <Button variant="primary-solid" data-testid="okta-oidc-error" mt={3}>
        {t("okta.oidc.error")}
      </Button>
    </SSOAuthenticationBox>
  );
};

export default LoginOidcCallbackErrors;
